import { put, call, all, takeEvery, take, delay } from "redux-saga/effects";
import generateAdmitcardActions from "./action";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";


const AdmitcardgeneratorSagas = function* () {
  yield all([
    yield takeEvery(
      generateAdmitcardActions.GENERATE_ADMIT_CARD,
      admitCardGenerator
    ),
    yield takeEvery(
      generateAdmitcardActions.GET_ADMIT_CARD_BATCH_STATUS,
      admitCardBatchStatus
    ),
    yield takeEvery(
      generateAdmitcardActions.DELETE_ADMIT_CARD,
      deleteAdmitCardGenerator
    ),
    yield takeEvery(
      generateAdmitcardActions.INSERT_EXTERNAL_COURSE,
      ExternaladmitCardCourse
    ),
    yield takeEvery(
      generateAdmitcardActions.GET_EXTERNAL_COURSE,
      Getexternalcourse
    ),
    yield takeEvery(
      generateAdmitcardActions.GENERATE_EXTERNAL_ADMITCARD,
      ExternalAdmitcardGenerator
    ),
    yield takeEvery(
      generateAdmitcardActions.ADD_EXTERNAL_COURSE,
      AddExternaladmitCardCourse
    ),
    yield takeEvery(
      generateAdmitcardActions.GENERATE_BULK_ADMITCARD,
      generateExternalbulkAdmitcard
    ),
    yield takeEvery(
      generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
      GetExternaladmitCardCount
    ),
    yield takeEvery(
      generateAdmitcardActions.GET_EXTERNAL_ZIPFILE,
      getExternalzipfile
    ),
    yield takeEvery(
      generateAdmitcardActions.GET_INTERNAL_ZIPFILE,
      getAdmitcardzipfile
    ),
  ]);
};


export function* admitCardGenerator(data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    console.log("payload", payload);
    // return;
    // let formData = new FormData();
    // let documentFile;
    // if (payload?.file != null) {
    //   documentFile = new File([payload?.file], payload?.file.name, {
    //     type: "application/xlsx",
    //   });
    // }
    // formData.append("Admitcard", documentFile ? documentFile : null);
    // const result = yield call(() =>
    //   axios.post(
    //     `${API_URL}/backoffice/admitcard/admit-card-generation/${
    //       documentFile == null ? 1 : 0
    //     }/${payload?.courseid}`,
    //     formData
    //   )
    // );
     const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/admit-card-batch`,
        payload
      )
    );
    // if (result?.data?.statusCode === 200) {
    //   payload?.setStatusModalOpen({
    //     open: true,
    //     statustext: "Processing...",
    //   });
    //   // let intervalId = payload.getDataInterval(result?.data?.data?.logid);
    //   // payload.setIntervalId(intervalId);
    // } else {
    //   payload?.setStatusModalOpen({
    //     open: false,
    //     statustext: "",
    //   });
    // }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

  } catch (err) {
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message:
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Failed to generate admit card",
      },
    });
    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } finally {

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
}

export function* admitCardBatchStatus(data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        // `${API_URL}/backoffice/admit-card-batch/status/${payload.courseid}`
        `${API_URL}/backoffice/admitcard/admit-card-batch/status?courseid=${payload.courseid}`
      )
    );
    console.log("Batch status result:", result);
      yield put({ type: generateAdmitcardActions.SET_ADMIT_CARD_BATCH_STATUS, payload: result?.data });
    yield put({ type: commonActions.SET_ALERT, payload: { status: "success", show: true, message: result?.data?.message } });
  } catch (error) {
    yield put({ type: commonActions.SET_ALERT, payload: { status: "failed", show: true, message: "Failed to fetch batch status" } });
  }
}

const ExternaladmitCardCourse = function* (data) {
  const { payload } = data;
  const formData = new FormData();

  let { admitcardtemplateurl, ...formDatas } = payload;
  for (let key in formDatas) {
    formData.append(key, payload[key]);
  }
  // formData.append("admitcardtemplateurl", new File(
  //   [payload?.admitcardtemplateurl],
  //   payload?.admitcardtemplateurl?.name,{
  //     type:"application/xlsx"
  //   }
  // ))
  formData.append("admitcardtemplateurl", payload.admitcardtemplateurl);

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/external-admit-card-generation`,
        formData
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "failed" : "success",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const AddExternaladmitCardCourse = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/external-admit-card-courses`,
        payload
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "failed" : "success",
        show: true,
        message: result?.data?.message,
      },
    });
    yield put({ type: generateAdmitcardActions.GET_EXTERNAL_COURSE });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const deleteAdmitCardGenerator = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.delete(
        `${API_URL}/backoffice/admitcard/admit-card-delete/${payload.courseid}`
      )
    );

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "failed" : "success",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    // Cookies.remove('mhet_mst_token');
    // window.location.href = `/${Cookies.get('mhet_mst_project')}/userlogin`;
  }
};
const Getexternalcourse = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/admitcard/external-admit-card-courses`)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: generateAdmitcardActions.SET_EXTERNAL_COURSE,
      payload: result?.data?.data,
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
};

const ExternalAdmitcardGenerator = function* (data) {
  const { payload } = data;


  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    let formData = new FormData();
    let documentFile;
    if (payload?.file != null) {
      documentFile = new File([payload?.file], payload?.file.name, {
        type: "application/xlsx",
      });
    }
    formData.append("externaladmitCard", documentFile ? documentFile : null);
    formData.append(
      "externalcourseid",
      payload?.externalcourseid ? payload?.externalcourseid : null
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/external-bulk-admit-card-generation`,
        formData
      )
    );

    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    if (result?.data?.statusCode === 200) {
      payload?.setOpen(false, "candidate");
      payload?.dispatch({
        type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
        payload: {
          externalcourseid: payload?.externalcourseid,
        },
      });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } finally {

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};
const generateExternalbulkAdmitcard = function* (data) {
  const { payload } = data;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });



  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/bulk-admit-card-generation`,
        payload
      )
    );
    if (result?.data?.statusCode == 200) {
      payload?.dispatch({
        type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
        payload: {
          externalcourseid: payload?.externalcourseid,
        },
      });
      payload?.setStatusModalOpen({
        open: true,
        statustext: "Processing...",
      });
      let intervalId = payload.getDataInterval(result?.data?.data?.logid);
      payload.setIntervalId(intervalId);
    } else {
      payload?.setStatusModalOpen({
        open: false,
        statustext: "",
      });
    }

    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } finally {
 
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};
const GetExternaladmitCardCount = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/external-admit-card-count`,
        payload
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: {
    //     status: result?.data?.statusCode === 200 ? "failed" : "success",
    //     show: true,
    //     message: result?.data?.message,
    //   },
    // });

    yield put({
      type: generateAdmitcardActions.SET_BULK_ADMITCARD_COUNT,
      payload: result?.data?.data,
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
// const getExternalzipfile = function* (data) {
//   const { payload } = data;
//   yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

//   yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
//   try {
//     const result = yield call(() =>
//       axios.post(
//         `${API_URL}/backoffice/admitcard/external-admit-card-zipfile`,
//         payload
//       )
//     );
//     yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
//     yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
//     yield put({
//       type: commonActions.SET_ALERT,
//       payload: {
//         status: result?.data?.statusCode === 200 ? "failed" : "success",
//         show: true,
//         message: result?.data?.message,
//       },
//     });

//     yield delay(2000);
//     yield put({
//       type: commonActions.SET_ALERT,
//       payload: { status: null, show: false, message: null },
//     });
//   } catch (err) {
//      ;
//   }
//   yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
//   yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
// };
const getExternalzipfile = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const response = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard/external-admit-card-zipfile`,
        payload,
        { responseType: 'blob' } // Important for file downloads
      )
    );

    // Create download link and trigger click
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'AdmitCards.zip');
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "success",
        show: true,
        message: "Downloaded successfully",
      },
    });

    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

  } catch (err) {
    console.error("Download error:", err);
    
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

    let errorMessage = "Failed to download zip file";
    if (err.response && err.response.data && typeof err.response.data === 'object') {
      try {
        // Try to read error message from blob if response was JSON
        const reader = new FileReader();
        reader.onload = function() {
          const text = JSON.parse(reader.result);
          errorMessage = text.message || errorMessage;
        };
        reader.readAsText(err.response.data);
      } catch (e) {
        errorMessage = err.response.statusText || errorMessage;
      }
    }

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: errorMessage,
      },
    });

    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  }
};
const getAdmitcardzipfile = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const response = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/admitcard//internal-admit-card-zipfile`,
        payload,
        { responseType: 'blob' } 
      )
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'AdmitCards.zip');
    document.body.appendChild(link);
    link.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "success",
        show: true,
        message: "Downloaded successfully",
      },
    });

    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

  } catch (err) {
    console.error("Download error:", err);
    
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

    let errorMessage = "Failed to download zip file";
    if (err.response && err.response.data && typeof err.response.data === 'object') {
      try {
        // Try to read error message from blob if response was JSON
        const reader = new FileReader();
        reader.onload = function() {
          const text = JSON.parse(reader.result);
          errorMessage = text.message || errorMessage;
        };
        reader.readAsText(err.response.data);
      } catch (e) {
        errorMessage = err.response.statusText || errorMessage;
      }
    }

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: errorMessage,
      },
    });

    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  }
};
export default AdmitcardgeneratorSagas;
